import Service from "../../../Services/index";

const productModule = {
    namespaced: true,
    state: {
        data: [],
        pack: [],
        productList: [],
        productsList: [],
        product_all: [],
        product_all_special: [],
        validate_product: "",
        search: {
            code: [],
            type: "",
            active: 1,
            special: [],
        },
        ProductForm: {
            name: "",
            short_name: "",
            code: "",
            price: 0.00,
            quantity: 0,
            min_quantity: 0,
            unit_quantity: null,
            product_type: null,
            pack: null,
            machine: null,
            employee_id: "",
            quantity_pack: "",
            size_form_id: null,
            special_product: null,
            onSave: false,
            material: null,
            commission: '',
        },
        dataPaginate: {
            current_page: 1,
            from: 1,
            last_page: 1,
            per_page: 1,
            total: 1,
            to: 1
        },
        specialPaginate: {
            current_page: 1,
            from: 1,
            last_page: 1,
            per_page: 1,
            total: 1,
            to: 1
        },
        special: [],
        specialPaginateFactory: {
            current_page: 1,
            from: 1,
            last_page: 1,
            per_page: 1,
            total: 1,
            to: 1
        },
        specialFactory: [],
        check_freez: false
    },
    mutations: {
        GET_PRODUCT_ALL: (state, data) => {
            state.product_all = data;
        },
        GET_PRODUCT_ALL_SPECIAL: (state, res) => {
            state.product_all_special = res.data;
            state.specialPaginate = {
                current_page: res.current_page,
                from: res.from,
                last_page: res.last_page,
                per_page: res.per_page,
                total: res.total,
                to: res.to
            }
        },
        GET_SPECIAL: (state, res) => {
            state.special = res.data;
            state.specialPaginate = {
                current_page: res.current_page,
                from: res.from,
                last_page: res.last_page,
                per_page: res.per_page,
                total: res.total,
                to: res.to
            }
        },
        GET_SPECIAL_FACTORY: (state, res) => {
            state.specialFactory = res.data;
            state.specialPaginateFactory = {
                current_page: res.current_page,
                from: res.from,
                last_page: res.last_page,
                per_page: res.per_page,
                total: res.total,
                to: res.to
            }
        },
        SET_DATA_FORM: (state, res) => {
            state.ProductForm = res;
            state.ProductForm.onSave = false;
        },
        SET_PRODUCT_LIST: (state, res) => {
            state.productList = res.data;
            state.dataPaginate = {
                current_page: res.current_page,
                from: res.from,
                last_page: res.last_page,
                per_page: res.per_page,
                total: res.total,
                to: res.to
            }
        },
        SET_PRODUCT_STOCK_LIST: (state, res) => {
            state.productsList = res.data;
            state.dataPaginate = {
                current_page: res.current_page,
                from: res.from,
                last_page: res.last_page,
                per_page: res.per_page,
                total: res.total,
                to: res.to
            }
        },
        CLEAR_FORM_DATA: state => {
            state.ProductForm = {
                name: "",
                short_name: "",
                code: "",
                price: 0.00,
                quantity: 0,
                min_quantity: 0,
                product_type: null,
                unit_quantity: null,
                pack: null,
                machine: null,
                employee_id: "",
                quantity_pack: "",
                size_form_id: null,
                special_product: null,
                onSave: false,
                material: null,
                commission: '',
            };
        },
        GET_PACK: (state, res) => {
            state.pack = res;
        },
        VALIDATE_DUPLICATE_PRODUCT: (state, res) => {
            state.validate_product = res;
        },
        CLEAR_SEARCH: (state) => {
            state.search = {
                code: "",
                type: "",
                active: 1,
                special: []
            }
        },
        FILTER_OPTION: (state, check) => {
            if (check.check && !check.tuyen) {
                state.product_all = state.product_all.filter(value => {
                    return value.cancel_status == null && (value.product_type_id == 14 || value.product_type_id == 17);
                });
            } else {
                state.product_all = state.product_all.filter(value => {
                    return value.cancel_status == null;
                });
            }
        }
    },
    actions: {
        filter_option({commit}, check) {
            commit("FILTER_OPTION", check);
        },
        setProducts({commit}, page = 1) {
            return Service.products.getProduct(page).then(res => {
                commit("SET_PRODUCT_LIST", res);
                return res;
            });
        },
        setProductsStock({commit}, page) {
            return Service.products.getProducts(page).then(res => {
                commit("SET_PRODUCT_STOCK_LIST", res);
            });
        },
        importExcel({commit}, data) {
            return Service.products.importExcel(data);
        },
        getPromotionOption({commit}) {
            return Service.products.getPromotionOption().then(res => {
                return res;
            });
        },
        getProductAll({commit}) {
            return Service.products.getProductAll().then(res => {
                commit("GET_PRODUCT_ALL", res);
            })
        },
        getSpecial({commit}, page) {
            return Service.products.getSpecial(page).then(res => {
                commit("GET_SPECIAL", res);
            })
        },
        getSpecialFactory({commit}, page) {
            return Service.products.getSpecialFactory(page).then(res => {
                commit("GET_SPECIAL_FACTORY", res);
            })
        },
        showSpecial({commit}, id) {
            return Service.products.showSpecial(id)
        },
        showSpecialFactory({commit}, id) {
            return Service.products.showSpecialFactory(id)
        },
        deleteSpecial({commit}, id) {
            return Service.products.deleteSpecial(id)
        },
        deleteSpecialFactory({commit}, id) {
            return Service.products.deleteSpecialFactory(id)
        },
        getProductAllSpecial({commit}, data) {
            return Service.products.getProductAllSpecial({'page': data.page, 'data': data.data}).then(res => {
                commit("GET_PRODUCT_ALL_SPECIAL", res);
            })
        },
        getProductAllSpecialFactory({commit}, data) {
            return Service.products.getProductAllSpecialFactory({'page': data.page, 'data': data.data}).then(res => {
                commit("GET_PRODUCT_ALL_SPECIAL", res);
            })
        },
        saveSpecial({commit}, data) {
            return Service.products.saveSpecial(data).then(() => {
            })
        },
        saveSpecialFactory({commit}, data) {
            return Service.products.saveSpecialFactory(data).then(() => {
            })
        },
        show({commit}, id) {
            return Service.products.showProduct(id).then(response => {
                commit("SET_DATA_FORM", response);
            });
        },
        save({commit, state}, {id, user}) {
            if (!state.ProductForm.quantity) {
                state.ProductForm.quantity = 0
            }
            const data = {
                name: state.ProductForm.name,
                short_name: state.ProductForm.short_name,
                product_type_id: state.ProductForm.product_type.id,
                unit_quantity: state.ProductForm.unit_quantity,
                pack_id: "",
                code: state.ProductForm.code,
                price: state.ProductForm.price,
                quantity: state.ProductForm.quantity,
                min_quantity: state.ProductForm.min_quantity,
                quantity_pack: state.ProductForm.quantity_pack,
                size_form_id: state.ProductForm.size_form_id,
                special_product: state.ProductForm.special_product,
                commission: state.ProductForm.commission,
                material_id: state.ProductForm.material ? state.ProductForm.material.id : null,
            };
            if (state.ProductForm.pack !== null) {
                data.pack_id = state.ProductForm.pack.id
            }
            if (!id) {//create
                return Service.products.createProduct(data).then(response => {
                    // //console.log(response);
                    commit("VALIDATE_DUPLICATE_PRODUCT", response);
                });
            } else { //update
                return Service.products.updateProduct(id, data).then(response => {
                    commit("VALIDATE_DUPLICATE_PRODUCT", response);
                });
            }
        },
        delete({commit}, id) {
            return Service.products.deleteProduct(id)
        },
        search({commit}, {page = 1, code, type, active}) {
            return Service.products.searchProduct(page, code, type, active).then(res => {
                commit("SET_PRODUCT_LIST", res);
                return res;
            });
        },
        searchWithSpecial({commit}, {page = 1, code, type, active, special}) {
            return Service.products.searchWithSpecial(page, code, type, active, special).then(res => {
                commit("SET_PRODUCT_LIST", res);
                return res;
            });
        },
        searchStock({commit}, {page = 1, code, type, active}) {
            return Service.products.searchProductStock(page, code, type, active).then(res => {
                commit("SET_PRODUCT_LIST", res);
                return res;
            });
        },
        clearFormData({commit}) {
            commit("CLEAR_FORM_DATA");
        },
        getPack({commit}) {
            return Service.products.getPackProduct().then(response => {
                commit('GET_PACK', response);
            })
        },
        clearSearch({commit}) {
            commit("CLEAR_SEARCH");
        },
        updatePriceProduct({commit}, data) {
            return Service.products.updatePriceProduct(data);
        },
        printProductPromotion({commit}, data) {
            return Service.products.printProductPromotion(data).then(res => {
                return res;
            });
        },
        updateCommissionProduct({commit}, data) {
            return Service.products.updateCommissionProduct(data);
        },
        createQuota({commit}, data) {
            return Service.products.createQuota(data);
        },
        indexQuota({commit}, data) {
            return Service.products.indexQuota(data);
        },
        listQuota({commit}, data) {
            return Service.products.listQuota(data);
        },
        listQuotaHistory({commit}, data) {
            return Service.products.listQuotaHistory(data);
        },
        editQuotaFix({commit}, data) {
            return Service.products.editQuotaFix(data);
        },
    }
};

export default productModule;
